import { useFormikContext } from 'formik'

import { FormikField } from '../../Formik'
import { InputField } from '../../Input'

import { GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME } from './GretaAIChatNameField.constants'
import { getGretaAIChatNameFieldNextValue } from './GretaAIChatNameField.utils'

function GretaAIChatNameField({
  hasCounter = false,
  inputProps,
  maxLength,
  placeholder,
  qaName,
}) {
  const { setFieldError } = useFormikContext()

  function handleChange() {
    setFieldError(GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME, undefined)
  }

  return (
    <FormikField
      forceFocus
      Component={InputField}
      getNextValue={getGretaAIChatNameFieldNextValue}
      hasCounter={hasCounter}
      inputProps={inputProps}
      maxLength={maxLength}
      name={GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME}
      placeholder={placeholder}
      qaName={qaName}
      onChange={handleChange}
    />
  )
}

export default GretaAIChatNameField
